import { render, staticRenderFns } from "./bankcashacc.vue?vue&type=template&id=4c010b5f"
import script from "./bankcashacc.vue?vue&type=script&lang=js"
export * from "./bankcashacc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports